<ng-container *ngIf="scenariosTableData?.cells?.length; else riskDataMissing">
	<section class="row padding-top-60">
		<h3 class="col-24 title-main">{{ componentTitle }}</h3>
		<section class="col-24 text-16 date" *ngIf="asOfDate"><span dcrHTMLKey="AS_OF_DATE_DYNAMIC" [dcrSubstitutions]="{ $asOfDate$: asOfDate }">As of $asOfDate$</span></section>
		<p class="col-24 disclaimer-container" dcrHTMLKey="RISK_SCENARIO_DISCLAIMER">
			Evaluate your portfolio's sensitivity to different factors and themes. Holdings have been converted to asset classes represented by market indexes, and 12 months of
			income yield are included for fixed income instruments
		</p>
	</section>

	<section class="row row-45 condensed-container">
		<section class="col-10">
			<button dz-button color="secondary" (click)="openScenarioSelectionDialog()" dcrHTMLKey="CHANGE_ADD_SCENARIOS">Change/Add sample scenarios</button>
		</section>

		<div class="col-14 toggle padding-left-10">
			<ac-chart-table-toggle [initialType]="toggleType.Chart" (newToggleStatus)="toggleChange($event)"></ac-chart-table-toggle>
		</div>
	</section>

	<section class="scenario-table grid margin-bottom-20">
		<!-- Header-->
		<section class="row row-30 col-header-row">
			<span [ngClass]="scenarioNameColumnClass" class="col-header-scenario col-scenario text-14-bold" dcrHTMLKey="SCENARIO_TABLE_HEADER">Scenario</span>
			<ng-container *ngIf="componentState === toggleType.Table; else chartHeader">
				<section
					*ngFor="let portfolio of scenariosTableData.headersX; index as colorIndex"
					[ngClass]="scenarioValueColumnClass"
					class="d-flex col-value justify-content-center text-align-center text-14-bold"
				>
					<icon [type]="iconType" [style.fill]="colors[colorIndex]" class="pull-left category-icon"></icon>
					<span>
						{{ portfolio.formattedValue }}
					</span>
				</section>
			</ng-container>
			<ng-template #chartHeader>
				<div [ngClass]="scenarioChartColumnClass" class="scenario-chart-header text-10">
					<div dcrHTMLKey="SCENARIOS_CHART_PERFORMANCE_HEADER" class="text-14-bold margin-top-20">Performance %</div>
					<div class="scenario-chart-header-values text-10">
						<span *ngFor="let xAxisValue of categories">{{ xAxisValue }}</span>
					</div>
				</div>
			</ng-template>
		</section>

		<!-- Main Table -->
		<ng-container *ngIf="componentState === toggleType.Table">
			<ng-container *ngFor="let header of scenariosTableData.headersY; index as i">
				<section class="row align-items-center" *ngIf="selectedScenarios.includes(header)">
					<section class="col-scenario" [ngClass]="scenarioNameColumnClass">
						<span class="text-16 text-md-14">
							{{ header.formattedValue }}
							<icon *ngIf="header.attribute.infoBubble" type="info-circle" class="info-circle text-14 color-primary" [tooltip]="infoBubble"> </icon>
							<dcr-cell-content [cell]="header"></dcr-cell-content>
							<ng-template #infoBubble> <section [innerHTML]="header.attribute.infoBubble"></section> </ng-template>
						</span>
					</section>
					<section
						[ngClass]="scenarioValueColumnClass"
						class="mobile-bordered padding-vertical-20 text-16 text-md-14 text-sm-12 col-value justify-content-center align-values"
						*ngFor="let value of scenariosTableData.cells[i]"
					>
						<span class="text-bold" [class.positive-value]="value.rawValue > 0" [class.negative-value]="value.rawValue <= 0">
							{{ value.formattedValue }}
						</span>
					</section>
				</section>
			</ng-container>
		</ng-container>

		<!-- Main Chart-->
		<ng-container *ngIf="componentState === toggleType.Chart">
			<ng-container *ngFor="let header of scenariosTableData.headersY; index as i">
				<section class="row align-items-center" *ngIf="selectedScenarios.includes(header)">
					<section class="col-scenario" [ngClass]="scenarioNameColumnClass">
						<span class="text-16 text-md-14">
							{{ header.formattedValue }}
							<icon *ngIf="header.attribute.infoBubble" type="info-circle" class="info-circle text-14 color-primary" [tooltip]="infoBubble"> </icon>
							<dcr-cell-content [cell]="header"></dcr-cell-content>
							<ng-template #infoBubble> <section [innerHTML]="header.attribute.infoBubble"></section> </ng-template>
						</span>
					</section>

					<section #barChartContainer [ngClass]="scenarioChartColumnClass" class="justify-content-center scenario-chart-border-left">
						<bfa-chart
							type="bar"
							name="center-align-scenario-chart"
							[data]="scenariosTabs[i]"
							[hasFullHeight]="true"
							[colors]="colors"
							[customAttributes]="customAttributes"
							[refreshEvent$]="refreshEvent$"
						></bfa-chart>
					</section>
				</section>
			</ng-container>
		</ng-container>
	</section>
	<section *ngIf="componentState === toggleType.Chart" class="legend">
		<section *ngFor="let portfolio of scenariosTableData.headersX; index as colorIndex" class="text-14-bold legend-item">
			<icon [type]="iconType" [style.fill]="colors[colorIndex]" class="pull-left category-icon"></icon>
			<span style="overflow-wrap: anywhere">
				{{ portfolio.formattedValue }}
			</span>
		</section>
	</section>
	<section class="padding-top-20">
		<section>{{ componentSource }}</section>
		<section>
			<ng-container *ngIf="asOfDate"><span dcrHTMLKey="AS_OF_DATE">As of: </span>{{ asOfDate }}</ng-container>
			<ng-container *ngIf="displayISOCurrency">
				<span dcrHTMLKey="CURRENCY"> Currency: </span>
				<span data-cy="scenarios-chart-table-disclosure-currency">{{ displayISOCurrency }}</span>
			</ng-container>
		</section>
	</section>
</ng-container>

<ng-template #riskDataMissing>
	<section>
		<icon class="warning-icon" type="exclamation-triangle"></icon>
		<span dcrHTMLKey="RISK_DATA_MISSING">Risk data for your portfolio(s) is missing. Please reload the page.</span>
	</section>
</ng-template>
